import { mdiHandBackRightOutline, mdiThumbUpOutline } from '@mdi/js';
import { Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import DashboardMetricPiece from './DashboardMetricPiece';
import { useDashboardData } from './useDashboardData';

const StudentFeedbackPaper = styled(Paper)`
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 17px 26px;
`;

const StyledHorizontalRule = styled.hr`
    width: 100%;
    border: 0.5px solid #979797;
    margin: 32px auto;
`;

const DashboardStudentFeedbackMetrics: React.FC = () => {
    const { sessionSummary: summary, classAverages } = useDashboardData();
    const { t } = useTranslation('dashboard');
    return (
        <StudentFeedbackPaper>
            <DashboardMetricPiece
                id="dashboard-metric-times-students-raised-hands"
                titleText={t('times-students-raised-hands')}
                titleIcon={mdiHandBackRightOutline}
                metricValue={summary.raisedHandCount.student}
                averageMetricValue={`${classAverages?.raisedHandCount.student}`}
                metricValueColor={'#BA36CE'}
            />
            <StyledHorizontalRule />
            <DashboardMetricPiece
                id="dashboard-metric-times-students-gave-feedback"
                titleText={t('times-students-gave-feedback')}
                titleIcon={mdiThumbUpOutline}
                metricValue={summary.feedbackCount.student}
                averageMetricValue={`${classAverages?.feedbackCount.student}`}
                metricValueColor={'primary'}
            />
        </StudentFeedbackPaper>
    );
};

export default DashboardStudentFeedbackMetrics;
